<div class="logo">
  <img class="img-fluid logo_img"  src="{{ sectionImage }}" alt="#">
  <div class="iq-font-{{ sectionColor }}  iq-mt-15">{{ sectionText }}</div>
  <ng-content></ng-content>
</div>
